import { sendRequestWithAuth } from '../common/sendRequest';
import * as settings from './settings';

export function getAdminHistoryWithTotal(filters, sort, limit) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_admin_history_with_total',
        limit,
        sort,
        filters
      })
    }
  );
}

export function getAdminHistory(filters, sort, limit, offset = null,) {
  return sendRequestWithAuth(
    settings.ServerURL, {
      method: 'POST',
      body: JSON.stringify({
        operation: 'get_admin_history',
        limit,
        offset,
        sort,
        filters
      })
    })
}



// WEBPACK FOOTER //
// ./src/services/adminHistory.js